// extracted by mini-css-extract-plugin
export var body = "text-comparison-module--body--6sFwe";
export var columnHeader = "text-comparison-module--columnHeader--qcbK9";
export var fontPatch = "text-comparison-module--fontPatch--5L9tU";
export var header = "text-comparison-module--header--ikq1G";
export var headerInvertFix = "text-comparison-module--headerInvertFix--p88kB";
export var icon = "text-comparison-module--icon--tt-zC";
export var row = "text-comparison-module--row--mhB3O";
export var split = "text-comparison-module--split--Bb6se";
export var textComparison = "text-comparison-module--textComparison--89Spo";